<template>
    <v-sheet>
      <v-container>
        <h2>Edycja nazwy schematu</h2>
        <v-text-field label="Nazwa schematu" v-model="schemaName"></v-text-field>
        <v-btn @click="save()"><v-icon color="green">mdi-check</v-icon></v-btn>
      </v-container>
    </v-sheet>
</template>

<script>
import Messenger from "@/plugins/Messenger";

export default {
  name: "EditName",
  props: ['schema'],
  data(){
    return {
      schemaName : ""
   }
  },
  methods:{
    save(){
      this.$http.put('schema/'+ this.schema.id,{'name': this.schemaName })
      .then(()=>this.$emit("updated",this.schemaName))
      .catch(()=>Messenger.emitError("Bład aktualizacji schematu"))
    }
  },
  watch:{
    schema:function () {
      if(this.schema){
        this.schemaName = this.schema.name
      }
    },

  }
}
</script>

<style scoped>

</style>